module.exports = __webpack_public_path__ + "img/toggle1.88aaeb46.png";